/**
 * Detect if a page was scrolled
 *
 * @param {string} scrolledClass – class to reflect that page was scrolled
 * @param {string} scrolledClassOn - element to set scrolledClass on
 * @param {number} scrolledThreshold – number of pixels that need to be scrolled
 */

import $ from 'jquery';

export const navScroll = (
    scrolledClass = 'ghwp-was-scrolled',
    scrolledClassOn = 'body',
    scrolledThreshold = 16
) => {
    $(window).scroll(function() {
        let expanded = $('#ghwp-main-toggle').attr('aria-expanded') === 'true';

        if ($(this).scrollTop() > scrolledThreshold) {
            $(scrolledClassOn).addClass(scrolledClass);
        } else {
            if (!expanded) {
                $(scrolledClassOn).removeClass(scrolledClass);
            }
        }
    });
};
